import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ReactGA from 'react-ga4';
import Connections from "./connections";

const Partners = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return (
    <>
      <header className="justify-content-center pt-5 pb-4 bg-warning text-center text-white shadow-sm mt-5">
        <div className="container">
          <div className="row mb-3">
            <div className="col">
              <h1 className="display-4 font-weight-bold">Partners</h1>
              <p className="lead opacity-8">Enterprise and Partnership-tailored and personalized Cloud Dashboard (PCD) Version {process.env.REACT_APP_VERSION}</p>
            </div>
          </div>
        </div>
      </header>
      <Connections />
    </>
  );
};

export default Partners;
